import React from 'react';
import SectionHead from '../../../ui-components/SectionHead';
import CompletedList from './components/completed-list/CompletedList';
import './completed-tasks.scss'

const CompletedTasks = () => {
    return (
        <div className="completed-tasks">
            <SectionHead head={"Completed Tasks"}/>
            <CompletedList/>
        </div>
    );
};

export default CompletedTasks;